<template>
  <div
    class="h-full bg-gray-100 rounded-md p-2.5 grid grid-cols-[1fr,30%] gap-3"
  >
    <div
      class="flex flex-col bg-white rounded-md p-2.5 gap-y-2 overflow-hidden"
    >
      <div
        class="nav gap-x-3"
        title="HuiWuDetailRenYuanList"
        data-title="分房管理"
      >
        <c_cell title="已选房间" v-if="state.select_room?.id">
          {{
            state.select_room?.hotel?.name +
            " - " +
            state.select_room?.hotelRoomType?.name +
            " - " +
            state.select_room?.floor +
            "楼 - " +
            state.select_room?.number
          }}
        </c_cell>
        <c_cell title="已选人员" v-if="state.select_attendee?.length > 0">
          {{
            state.select_attendee?.map((w) => w.conferee?.name).join("、") ||
            "无"
          }}
        </c_cell>
        <el-button
          v-if="state.select_room?.id && state.select_attendee?.length > 0"
          type="success"
          icon="select"
          @click="onSubmit"
          >确认分房</el-button
        >
        <el-button
          v-if="state.select_room?.id && state.select_attendee?.length > 0"
          type="danger"
          link
          size="small"
          @click="
            state.select_attendee = [];
            delete state.select_room;
          "
          :disabled="!state.select_attendee?.length"
        >
          × 重新选择<text v-if="state.select_attendee?.length">
            ({{ state.select_attendee?.length }})
          </text>
        </el-button>
      </div>
      <div class="flex flex-wrap items-center gap-x-3 gap-y-2 mt-2">
        <div class="flex items-center gap-x-1 text-sm text-gray-500">
          <text>入住日期:</text>
          <el-date-picker
            v-model="state.params.checkin_date"
            type="date"
            value-format="YYYY-MM-DD"
            size="default"
            class="!w-160px"
          />
        </div>
        <div class="flex items-center gap-x-1 text-sm text-gray-500">
          <text>入住天数:</text>
          <el-input-number
            v-model="state.params.checkin_day_count"
            :min="1"
            :max="30"
            size="default"
            class="!w-28"
          />
        </div>
        <div class="flex items-center gap-x-1 text-sm text-gray-500">
          <text>所属酒店:</text>
          <el-select
            v-model="state.params.hotel_id"
            filterable
            clearable
            placeholder="全部酒店"
            size="default"
            class="!w-40"
          >
            <el-option
              v-for="h in state.hotel_list"
              :key="h.id"
              :label="h.name"
              :value="h.id"
            />
          </el-select>
        </div>
        <div class="flex items-center gap-x-1 text-sm text-gray-500">
          <text>房型:</text>
          <el-select
            v-model="state.params.room_type_id"
            filterable
            clearable
            placeholder="全部房型"
            size="default"
            class="!w-32"
          >
            <el-option
              v-for="t in state.room_type_list"
              :key="t.id"
              :label="t.name"
              :value="t.id"
            />
          </el-select>
        </div>
        <el-button
          type="primary"
          size="default"
          @click="
            onLoadHotel();
            onLoadAttendee();
          "
          class="!ml-[-5px]"
        >
          搜索
        </el-button>
        <el-button
          type="primary"
          link
          size="default"
          :icon="Download"
          @click="onExport"
        >
          导出Excel
        </el-button>
      </div>
      <div
        class="flex-1 overflow-y-auto bg-gray-100 rounded-md p-2.5 overflow-hidden"
      >
        <div
          class="bg-white rounded-lg shadow-sm overflow-hidden flex flex-col h-full"
        >
          <div class="flex-1 overflow-y-auto p-4">
            <div
              v-if="!state.list_data?.length > 0"
              class="text-center text-gray-400 py-20"
            >
              请填写“入住日期”和“入住天数”后点击搜索已配置的酒店房间
            </div>
            <div
              v-for="hotel in state.list_data"
              :key="hotel.id"
              class="mb-5 last:mb-0"
            >
              <!-- 酒店标题 -->
              <div class="flex items-center gap-x-2 mb-2">
                <text class="font-bold text-gray-800">{{ hotel.name }}</text>
                <text class="text-xs text-gray-400">{{ hotel.address }}</text>
              </div>
              <!-- 楼层分组 -->
              <div
                v-for="floor in hotel.floors"
                :key="floor.name"
                class="mb-4 last:mb-0"
              >
                <text class="text-sm text-gray-500 block mb-1">
                  {{ floor.name + "楼" }}
                </text>
                <!-- 房间行 -->
                <div class="flex flex-wrap gap-2">
                  <div
                    v-for="room in floor?.rooms"
                    :key="room.id"
                    class="room-cell relative"
                    :class="getRoomClass(room)"
                    @click="state.select_room = room"
                  >
                    <!-- 房号+床位 -->
                    <div
                      class="text-xs mb-0.5 flex justify-between items-center"
                    >
                      <text class="font-bold">{{ room.number }}</text>
                      <text class="opacity-70"
                        >{{ room.checkin_num }}/{{ room.guest_num }}</text
                      >
                    </div>
                    <!-- 房型 -->
                    <div class="text-xs mb-1 opacity-80">
                      {{ room.hotelRoomType?.name }}
                    </div>
                    <!-- 已分配人员 -->
                    <div class="flex flex-wrap gap-1">
                      <template v-if="room.meetingAttendeeRoom?.length > 0">
                        <div
                          v-for="a in room.meetingAttendeeRoom"
                          :key="a.id"
                          class="room-attendee-tag"
                          :class="
                            a.meetingAttendee?.conferee?.sex == '男' &&
                            state.select_room?.id != room.id
                              ? '!text-blue-500'
                              : '!text-red-500 !bg-red-200'
                          "
                        >
                          {{ a.meetingAttendee?.conferee?.name }}
                        </div>
                      </template>
                      <div v-else class="empty-tag">空</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col bg-white rounded-md p-2.5">
      <!-- 右侧：参会人员列表 -->
      <div class="bg-white rounded-lg shadow-sm overflow-hidden flex flex-col">
        <!-- 标题 -->
        <div class="text-center font-bold py-2.5 border-b text-gray-800">
          参会人员
        </div>
        <div class="text-center mt-2">
          <!-- 已分配/未分配 Tabs -->
          <el-segmented
            v-model="state.attendee_params.is_allocate"
            :options="[
              { label: '待分配', value: 0 },
              { label: '已分配', value: 1 },
            ]"
            class="c-segmented w-56"
            @change="onLoadAttendee()"
          />
        </div>
        <!-- 搜索栏 -->
        <div class="px-3 py-2 border-b">
          <div class="flex items-center gap-x-2">
            <el-input
              v-model="state.attendee_params.keywords"
              placeholder="关键字"
              clearable
              size="default"
              class="flex-1"
            >
              <template #suffix>
                <el-icon color="#a2a2a2" title="搜索" class="cursor-pointer">
                  <Search />
                </el-icon>
              </template>
            </el-input>
            <strong class="text-xs">只看嘉宾</strong>
            <el-switch v-model="state.only_guest" />
            <el-button
              type="danger"
              link
              size="small"
              @click="onCancel"
              :disabled="!state.select_attendee?.length"
            >
              × 取消分配<text v-if="state.select_attendee?.length > 0"
                >({{ state.select_attendee?.length }})</text
              >
            </el-button>
          </div>
        </div>
        <!-- 人员列表 -->
        <div class="flex-1 overflow-y-auto px-2 py-2">
          <div
            v-if="state.attendee_data?.length === 0"
            class="text-center text-gray-400 py-10 text-sm"
          >
            {{ state.attendee_tab === 1 ? "暂无已分配人员" : "暂无未分配人员" }}
          </div>
          <div
            v-for="item in state.attendee_data"
            :key="item.id"
            class="attendee-card"
            :class="
              state.select_attendee?.some((w) => w.id == item.id)
                ? 'shadow-[0_0_2px_1px_var(--el-color-primary)]'
                : ''
            "
            @click="onSelectAttendee(item)"
          >
            <div class="flex items-start gap-x-2">
              <c_Avatar
                v-if="item.id"
                :file_url="item.conferee?.avatar_attachment?.file_url"
                :size="10"
                :title="item.conferee?.name?.slice(0, 1)"
              />
              <div class="flex-1">
                <ul class="flex items-center">
                  <li class="flex-1 gap-x-3 flex items-center">
                    <strong
                      style="color: var(--el-color-primary)"
                      class="cursor-pointer hover:underline"
                    >
                      {{ item.conferee?.name }}
                    </strong>
                    <c_sex :value="item.conferee?.sex" />
                    <text class="text-sm text-gray-400">{{
                      $phoneFormat(item.conferee?.phone)
                    }}</text>
                    <c_status
                      arrName="Meeting_Attend_Type"
                      :value="item.attend_type"
                      :key="item.attend_type"
                      showBg
                    />
                  </li>
                </ul>
                <ul class="flex flex-wrap gap-x-2 gap-y-1">
                  {{
                    item.d_attend_role_name
                  }}
                </ul>
              </div>
            </div>
            <!-- 房号 -->
            <div
              v-if="item.room_no"
              class="flex items-center justify-between mt-1.5"
            >
              <text class="text-xs text-gray-500">{{ item.room_no }}</text>
              <el-icon
                color="#f00"
                class="cursor-pointer hover:scale-110"
                @click="onRemoveAttendee(item)"
              >
                <Close />
              </el-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, reactive } from "vue";
import { Download } from "@element-plus/icons-vue";
import {
  meeting_service_hotel_arrange_room_page,
  meeting_service_hotel_arrange_room_attendee_page,
  meeting_service_hotel_arrange_room_allocateAttendee,
  meeting_service_hotel_arrange_room_allocateAttendeeCancel,
} from "@/http/meetingservice";
import { ElMessageBox, ElMessage } from "element-plus";

export default {
  props: {
    meeting_id: Number,
  },
  components: {},
  setup(props) {
    const state = reactive({
      params: {
        meeting_id: props.meeting_id,
        checkin_date: "2026-09-01",
        checkin_day_count: 1,
      },
      attendee_params: {
        meeting_id: props.meeting_id,
        is_allocate: 0,
      },
      select_room: {}, //已选房间
      select_attendee: [], //已选人员
    });

    onMounted(() => {});

    //获取酒店房间
    const onLoadHotel = () => {
      meeting_service_hotel_arrange_room_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list } = res.data?.data || {};
          let hotels = list.reduce((acc, cur) => {
            if (!acc?.some((w) => w.id == cur.hotel_id)) {
              acc.push({
                id: cur.hotel_id,
                name: cur.hotel?.name,
              });
            }
            return acc;
          }, []);

          let list_data = [];
          hotels.forEach((hotel) => {
            let floors = list
              .filter((a) => a.hotel_id == hotel.id)
              .reduce((acc, cur) => {
                if (!acc?.some((w) => w.name == cur.floor)) {
                  acc.push({
                    name: cur.floor,
                  });
                }
                return acc;
              }, []);
            floors.forEach((floor) => {
              floor.rooms = list.filter((w) => w.floor == floor.name);
            });
            hotel.floors = floors;
            list_data.push(hotel);
          });
          state.list_data = list_data;
        }
      });
    };

    const onLoadAttendee = () => {
      state.attendee_params.checkin_date = state.params.checkin_date;
      state.attendee_params.checkin_day_count = state.params.checkin_day_count;
      meeting_service_hotel_arrange_room_attendee_page(
        state.attendee_params,
      ).then((res) => {
        if (res.status == 200) {
          const { list } = res.data?.data || {};
          state.attendee_data = list;
        }
      });
    };

    // // 重置筛选
    // const onReset = () => {
    //   state.params = {
    //     status: "",
    //     check_in_date: "",
    //     days: 1,
    //     hotel_id: "",
    //     room_type_id: "",
    //   };
    //   onLoad();
    // };

    // // 导出
    // const onExport = () => {
    //   console.log("导出Excel");
    //   // TODO: 对接导出 API
    // };

    // 根据房间状态返回样式类
    const getRoomClass = (room) => {
      const hasAttendee = room.checkin_num > 0;
      if (state.select_room?.id == room.id) return "room-select";

      if (!hasAttendee) return "room-empty";
      if (room.checkin_num >= room.guest_num) return "room-full";

      return "room-partial";
    };

    const onSelectAttendee = (item) => {
      state.select_attendee = state.select_attendee?.some(
        (w) => w.id == item.id,
      )
        ? state.select_attendee.filter((w) => w.id != item.id)
        : [...state.select_attendee, item];
    };

    const onSubmit = () => {
      if (!state.select_room?.id) {
        ElMessage.error("请选择房间");
        return;
      }
      if (!state.select_attendee?.length) {
        ElMessage.error("请选择参会人员");
        return;
      }

      ElMessageBox.confirm(
        `您确定将已选参会人<strong style="color:#1e90ff">${state.select_attendee
          ?.map((w) => w.conferee?.name)
          .join("、")}</strong>分配到<strong style='color:#080'>${
          state.select_room?.hotel?.name +
          " - " +
          state.select_room?.hotelRoomType?.name +
          " - " +
          state.select_room?.floor +
          "楼 - " +
          state.select_room?.number
        }</strong>吗？`,
        "确认分房",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meeting_service_hotel_arrange_room_allocateAttendee({
          meeting_attendee_id: state.select_attendee?.map((w) => w.id),
          hotel_room_type_id: state.select_room?.hotelRoomType?.id,
          number: state.select_room?.number,
          checkin_date: state.params.checkin_date,
          checkin_day_count: state.params.checkin_day_count,
        }).then((res) => {
          if (res.status == 200) {
            ElMessage.success("分配成功");
            onload();
            onLoadAttendee();
          }
        });
      });
    };

    const onCancel = () => {
      ElMessageBox.confirm(
        `您确定<strong style="color:#f00">取消</strong>已选${state.select_attendee?.length}人分配的房间吗？`,
        "取消分配",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meeting_service_hotel_arrange_room_allocateAttendeeCancel({
          id: state.select_attendee?.map((w) => w.id),
        }).then((res) => {
          if (res.status == 200) {
            ElMessage.success("操作成功");
            onload();
            onLoadAttendee();
            state.select_attendee = [];
          }
        });
      });
    };

    return {
      state,
      onLoadHotel,
      onLoadAttendee,
      getRoomClass,
      onSelectAttendee,
      onSubmit,
      onCancel,
    };
  },
};
</script>

<style lang="scss" scoped>
.fenfang-page {
  font-size: 14px;
}

/* 房间格子通用 */
.room-cell {
  width: 108px;
  min-height: 80px;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
  border: 2px solid transparent;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
}
.room-cell:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
}

/* 空房 */
.room-cell.room-empty {
  background: #e8f5e9;
  border-color: #66bb6a;
  color: #2e7d32;
}

/* 部分分配 */
.room-cell.room-partial {
  background: #fff3e0;
  border-color: #ffa726;
  color: #e65100;
}

/* 已分配（满员） */
.room-cell.room-full {
  background: #e3f2fd;
  border-color: #42a5f5;
  color: #1565c0;
}

/* 已分配（满员） */
.room-cell.room-select {
  background: #fff;
  border-color: #f30b0b;
  color: #cb1f1c;
}

/* 空房标签 */
.empty-tag {
  display: inline-block;
  padding: 1px 6px;
  font-size: 11px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.06);
  color: inherit;
  text-align: center;
}

/* 房间内已分配人员标签 */
.room-attendee-tag {
  display: inline-block;
  padding: 1px 6px;
  font-size: 11px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.06);
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 参会人员卡片 */
.attendee-card {
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 8px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  transition: all 0.15s;
}
.attendee-card:hover {
  background: #f5f5f5;
  border-color: #e0e0e0;
}

/* 覆盖 Element Plus radio-button 样式 */
.el-radio-button__inner {
  padding: 5px 14px !important;
}

/* 覆盖 number-input-left 等类 */
.number-input-left .el-input-number__decrease {
  right: auto;
  left: 1px;
  border-radius: 4px 0 0 4px;
}
</style>
